<ng-container>
  <!-- <ng-container>
    <ion-row class="ion-margin-vertical">
      <ion-col>
        <img
          src="assets/images/aefireport.svg"
          clsss="verified-logo"
        />
        <p>
          {{
            "Previous Vaccines are not available for this member"
              | translate
          }}
        </p>
      </ion-col>
    </ion-row>
  </ng-container> -->
  <ng-container>
    <ion-grid class="vaccines-grid previousVaccinationBg">
      <ion-row class="vaccine-names">
        <ion-col size="12" size-lg="12">
          <mat-checkbox color="primary" class="example-margin">
            Bacillus Calmette Guerin (BCG)
          </mat-checkbox>
        </ion-col>
      </ion-row>
      <ng-container>
        <ion-row class="fade-in">
          <mat-radio-group>
            <ion-card class="detailsCard">
              <ion-row class="dose-labels">
                <ion-col size="5">
                  <mat-checkbox class="example-margin" color="primary"
                    >OPV-1
                  </mat-checkbox>
                </ion-col>
                <ion-col size="7">
                  <mat-form-field appearance="outline" class="matDropdown">
                    <input matInput readonly />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="dp"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #dp></mat-datepicker>
                  </mat-form-field>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12">
                  <ion-item class="completed">
                    <!-- <ion-label>{{d.material_id == environment.static_ids.OPV_Vaccine ? 'OPV' : 'Dose'}}
                  {{d.material_id == environment.static_ids.OPV_Vaccine ? d.dose - 1 : d.dose }}</ion-label> -->
                    <ion-label> OPV-2 </ion-label>
                    <ion-note slot="end">{{ "Updated" | translate }}</ion-note>
                  </ion-item>
                </ion-col>
              </ion-row>
            </ion-card>
          </mat-radio-group>
        </ion-row>
        <ion-row class="vaccine-names">
          <ion-col size="12" size-lg="12">
            <mat-checkbox color="primary" class="example-margin">
              Hepatitis B-Birth dose
            </mat-checkbox>
          </ion-col>
        </ion-row>
        <ion-row class="ion-margin-vertical">
          <ion-col>
            <ion-label>{{ "Dose Date" | translate }}</ion-label>
            <mat-form-field
              appearance="outline"
              class="matDropdown ion-margin-vertical"
            >
              <input readonly matInput />
              <mat-datepicker-toggle
                matSuffix
                [for]="dp"
              ></mat-datepicker-toggle>
              <mat-datepicker #dp></mat-datepicker>
            </mat-form-field>
          </ion-col>
        </ion-row>
      </ng-container>
    </ion-grid>
  </ng-container>
</ng-container>
